var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignUpBackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:none;}.b{stroke:#22313f;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-696 -4440)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 24,
    height: 24,
    transform: "translate(696 4440)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(694.36 4438.523)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 16,
    transform: "translate(6.28 13.476)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M13.476,21.953,5,13.476,13.476,5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignUpBackIcon);
export default __webpack_public_path__ + "static/media/sign-up-back-icon.1d276d6bad4e5e951caec3bdd6132aa5.svg";
export { ForwardRef as ReactComponent };